export default "__VITE_ASSET__CuLiFOF2__"